import { gql } from '@apollo/client';

export const GET_SALON_SERVICES_GROUPED_BY_CATEGORY = gql`
  query GetSalonServicesGroupedByCategory($salonId: ID!) {
    getSalonServicesGroupedByCategory(salonId: $salonId) {
      category {
        id
        category_name
      }
      services {
        id
        description
        price
        duration
        status
        service {
          id
          service_name
        }
      }
    }
  }
`;

export const WEB_CHECKIN = gql`
  mutation WebCheckin($input: WebCheckinInput!) {
    webCheckin(input: $input) {
      success
      message
      booking {
        id
        booking_start_time
        booking_status
        checkin_timestamp
      }
      customer {
        id
        name
        phone
        signup_source
      }
    }
  }
`;
